import React from "react";
import TrackVisibility from "react-on-screen";
import cn from "classnames";
import { Col, Row } from "antd";
import Wrapper from "../LandingBlockWrapper/BlockWrapper";
import { FormattedMessage, injectIntl } from "react-intl";
import messages from "./messages";
import AnimatedList from "../LandingAnimatedList";

import icon1 from "../../assets/icons/6.svg";
import icon2 from "../../assets/icons/7.svg";
import icon3 from "../../assets/icons/8.svg";
import icon6 from "../../assets/icons/11.svg";

const listData = [
	{
		icon: icon1,
		label: messages.titleIcon1,
		text: messages.labelIcon1,
	}, {
		icon: icon3,
		label: messages.titleIcon3,
		text: messages.labelIcon3,
	}, {
		icon: icon2,
		label: messages.titleIcon2,
		text: messages.labelIcon2,
	}, {
		icon: icon6,
		label: messages.titleIcon6,
		text: messages.labelIcon6,
	}
];


const List = ({ currentIndex, stopTimer, startTimer, listData }) => {
	return (
		<Row type="flex" gutter={38}>
			{listData.map((i, index) => (<Col key={i.icon} xs={24} sm={24} md={12} lg={12}>
				<Item
					onMouseEnter={e => stopTimer(index)}
					onMouseLeave={startTimer}
					selected={currentIndex === index}
					index={index} {...i}/>
			</Col>))}
		</Row>
	);
};

const Item = injectIntl(({ selected, icon, label, text, index, intl: { formatMessage }, ...props }) => (
	<div className={cn("Item", selected && "selected")} {...props}>
		<section>
			<img className="icon" alt={"icon"} src={icon}/>
			<div className="description">{formatMessage(text)}</div>
		</section>
		<div>{`${index + 1}. ${formatMessage(label)}`}</div>
	</div>
));

export default () => {
	return <Wrapper className="HowItWorks">
		<h2>
			<FormattedMessage {...messages.title} />
		</h2>
		<TrackVisibility partialVisibility>
			<AnimatedList listDataLength={listData.length}>
				<List listData={listData}/>
			</AnimatedList>
		</TrackVisibility>
	</Wrapper>;
}


// WEBPACK FOOTER //
// ./src/components/LandingHowItWorks/HowItWorks.js